import { createQueryKeys } from 'query-keys';
import { EquipmentId } from '../../../slices/equipments';
import { DeviceSessionId, EquipmentSessionId, ParcelSessionId } from '../../../slices/sessions';

type TracksParams = { equipmentId?: EquipmentId; start?: string; end?: string };

export const sessionQueryKeys = createQueryKeys('sessions', {
  shared: (id: string) => ({ id }),
  forcedOrIgnoredParcels: (deviceSessionId: DeviceSessionId) => ({ deviceSessionId }),
  equipmentSessionPoints: (id?: EquipmentSessionId) => ({ id }),
  equipmentTracks: (params: TracksParams) => params,
  parcelTracks: (params: TracksParams) => params,
  equipmentSessionWorkedArea: (id?: EquipmentSessionId) => ({ id }),
  equipmentSessionsWorkedArea: (ids: EquipmentSessionId[]) => ({ ids }),
  parcelSessionWorkedArea: (id?: ParcelSessionId) => ({ id }),
  parcelSessionsWorkedArea: (ids: ParcelSessionId[]) => ({ ids }),
});
